import { Injectable } from '@angular/core';

import { StageService } from '../../services/stage.service';
import { AwningService } from '../../services/awning/awning.service';
import { CameraLayers } from '../../enum/CameraLayers';
import { Button } from './Button';

declare const THREE: any;

@Injectable()
export class AwningDeleteControl extends (THREE.Object3D as { new (): any }) {
  private _left: any;
  private _right: any;
  private _base: any;

  constructor(private stageService: StageService, private awningService: AwningService) {
    super();
    this._left = this._buildControl('left');
    this._right = this._buildControl('right');
    this._base = this._buildControl('base');
    this._left.visible = this._right.visible = false;
    this.add(this._left);
    this.add(this._right);
    this.add(this._base);
    this.visible = false;
    this.name = 'awningDeleteControls';
    this.stageService.add(this);
  }

  private _buildControl(name: string) {
    const texture = new THREE.TextureLoader().load('assets/images/objectControls/delete.png');
    const button = new Button(texture, name, CameraLayers.HORIZONTAL_RESIZE);
    button.position.y = 30 / 2;
    return button;
  }

  update(awning) {
    [this._left, this._right].forEach(lr => (lr.visible = false));
    const groupPosition = this.awningService.getCenter(awning);
    this.position.copy(groupPosition);
    const extensions = this.awningService.getExtensions(awning);
    if (extensions.length) {
      const lastInRow = extensions.filter(e => this.awningService.isLastInRow(e));
      const left = lastInRow.find(linr => {
        const { awningType } = linr.userData.entity;
        return this.awningService.getAwningPositionType(awningType) === 'left';
      });
      const right = lastInRow.find(linr => {
        const { awningType } = linr.userData.entity;
        return this.awningService.getAwningPositionType(awningType) === 'right';
      });

      if (left) {
        this._left.visible = true;
        this._left.position.copy(
          this.worldToLocal(left.getWorldPosition(new THREE.Vector3(0, 0, 0)))
        );
      }
      if (right) {
        this._right.visible = true;
        right.updateMatrixWorld();
        this._right.position.copy(
          this.worldToLocal(right.getWorldPosition(new THREE.Vector3(0, 0, 0)))
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/custom/Controls/AwningDeleteControl.ts